<template>
  <div class="eqChart">
    <el-card>
      <div slot="header"
           class="clearfix">
        <span>{{$t('menu.dtqstb')}}</span>
      </div>
      <div class="eq-name">
        <div>设备位号：{{meter}}</div>
        <div>设备名称：{{name}}</div>
      </div>
      <div class="eq-tools">
        <div>
          <el-radio-group size="mini" v-model="searchType" @change="changeType">
            <el-radio-button label="2">日</el-radio-button>
            <el-radio-button label="1">月</el-radio-button>
          </el-radio-group>
          <el-date-picker
            v-model="dateMonth"
            @change="dcsDate"
            type="date"
            size="mini"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </div>
        <div class="eq-tips">
          <div class="tips-1"><i></i>正常数据</div>
          <div class="tips-2"><i></i>异常数据</div>
        </div>
      </div>
      <div id="echartContainer"
           style="width:800px; height:500px"></div>
    </el-card>
  </div>
</template>

<script>
import ApiService from '@/services/API-services'
var echarts = require('echarts')
export default {
  name: 'eqChart',
  data() {
    return {
      myChart: null,
      chartOption: null,
      chartTimer: null,
      dateMonth: '',
      meter: '',
      name: '',
      searchType: 2
    }
  },
  created() {
    console.log(this.$store.state.eqData)
    this.meter = this.$store.state.eqData.deviceName
    this.name = this.$store.state.eqData.tagDes
    this.timeWeekFormat()
  },
  computed: {
    dataChange() {
      return this.$store.state.eqData.deviceName
    }
  },
  watch: {
    dataChange(val) {
      this.meter = val
      this.getDcsData()
    }
  },
  mounted() {
  },
  destroyed() {
    // clearInterval(this.chartTimer)
  },
  methods: {
    changeType(val) {
      // console.log(val)
      this.searchType = val
      this.getDcsData()
    },
    dcsDate() {
      this.getDcsData()
    },
    getDcsData() {
      ApiService.views.getDcsData({
        DateStr: Number(this.searchType) === 2 ?this.dateMonth: this.dateMonth.substring(0,7),
        BitNumber: this.$store.state.eqData.deviceName,
        Type: Number(this.searchType)
      }).then(res => {
        this.drawChart(res.data)
      })
    },
    setTimer() {
      clearInterval(this.chartTimer)
      let app = { 'count': 31 }
      this.chartTimer = setInterval(() => {
        let axisData = (new Date()).toLocaleTimeString().replace(/^\D*/, '')


        var data0 = this.chartOption.series[0].data
        if (data0.length >= 30) {
          data0.shift()
        }
        data0.push(this.$store.state.eqData.qValue)
        if (data0.length >= 30) {
          this.chartOption.xAxis[0].data.shift()
          this.chartOption.xAxis[0].data.push(axisData)

          this.chartOption.xAxis[1].data.shift()
          this.chartOption.xAxis[1].data.push(app.count++)
        }
        this.myChart.setOption(this.chartOption)
      }, 1000)
    },
    timeWeekFormat() {
      // 定义一个日期对象
      var dateTime = new Date(Date.now())
      // 获得系统年份
      var year = dateTime.getFullYear()
      // 获得系统月份
      var month = dateTime.getMonth() + 1
      // 获得系统当月分天数
      var day = dateTime.getDate()
      month < 10 ? (month = '0' + month) : month
      day < 10 ? (day = '0' + day) : day
      // 打印完整的系统日期;
      this.dateMonth = year + '-' + month + '-' + day
      // return dateStr;
      this.dcsDate()
    },
    drawChart(val) {
      // 基于准备好的dom，初始化echarts实例
      this.myChart = echarts.init(document.getElementById('echartContainer'))
      // 绘制图表
      let dates = val.map((n) => {
        return n.time + (Number(this.searchType) === 2? '时':'月')
      })
      let warnMin = this.$store.state.eqData.offlineValues
      let warnMax = this.$store.state.eqData.onlineValue
      let datas = val.map(n => {
        if (n.minValue < warnMin || n.maxValue > warnMax) {
          return {
            value: [n.minValue, n.maxValue, n.minValue, n.maxValue],
            itemStyle: {
              color: '#1D2C48',
              color0: '#1D2C48',
              borderColor: '#ED4113', // red
              // borderColor: '#1bbd6b', // green
              borderColor0: '#1bbd6b'
            },
          }
        } else {
          return {
            value: [n.minValue, n.maxValue, n.minValue, n.maxValue],
            itemStyle: {
              color: '#1D2C48',
              color0: '#1D2C48',
              // borderColor: '#ED4113', // red
              borderColor: '#1bbd6b', // green
              borderColor0: '#1bbd6b'
            },

          }
        }
      })
      let option = {
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          top: '10%',
          containLabel: true
        },
        tooltip: {
          formatter: function (params) {
            console.log(params)
            return '最小值：' + params[0].value[1]+'<br>'+'最大值：' + params[0].value[2];
          },
          trigger: 'axis',
          axisPointer: {
            animation: false,
            type: 'cross',
            lineStyle: {
              color: '#fff',
              width: 2,
              opacity: 1
            }
          }
        },
        xAxis: {
          data: dates,
          axisLabel: {
            textStyle: {
              color: "rgba(255,255,255,.9)",
              fontSize: "12"
            }
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: ["rgba(22,85,130,.4)"],
              // width: 1,
              type: "dashed"
            }
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(22,85,130,.4)'
            }
          }
        },
        yAxis: {
          name: '温度/℃',
          nameTextStyle: {
            color: '#fff'
          },
          axisLabel: {
            textStyle: {
              color: "rgba(255,255,255,.9)",
              fontSize: "12"
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ["rgba(22,85,130,.4)"],
              width: 1,
              type: "solid"
            }
          },
          axisLine: {
            lineStyle: {
                color: 'rgba(22,85,130,.4)'
            }
          },
        },
        series: [{
          type: 'k',
          data: datas
        }]
      }
      this.chartOption = option
      this.myChart.setOption(this.chartOption)
    }
  }
}
</script>

<style lang="scss">
.eqChart {
  .el-card {
    border: 0;
    .eq-name {
      color: #fff;
      font-size: 14px;
      text-align: left;
      border-bottom: 1px solid rgba(255,255,255,.2);
      padding-bottom: 10px;
      margin-bottom: 10px;
    }
    .eq-tools {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .el-input__inner {
        background-color: #1D2C48;
        border-color: rgba(255, 255, 255, .85);
      }
      .el-radio-group {
        margin-right: 15px;
      }
      .el-radio-button__inner {
        background: #1D2C48;
        color: #fff;
      }
      .el-radio-button__orig-radio:checked+.el-radio-button__inner {
        
        background: #409eff;
      }
      .eq-tips {
        color: #fff;
        font-size: 14px;
        display: flex;
        .tips-1, .tips-2 {
          display: flex;
          align-items: center;
          i {
            width: 12px;
            height: 12px;
            border-radius: 50%;
            background-color: #1BBD6B;
            margin-right: 10px;
          }
        }
        .tips-2 {
          margin-left: 20px;
          i {
            background-color: #ED4113;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/equipment/eqChart.vue